import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { OrganisationDetailPage } from "@/modules/organisations/OrganisationDetailPage";
import { OrganisationsPage } from "@/modules/organisations/OrganisationsPage";
import { OrgUsersPage } from "@/modules/organisations/UsersPage";

/** Organisations — parties, their people, and what each may do.
 *
 *  WHY THESE SUBPAGES AND NOT OTHERS. A record lives where it is MANAGED and is
 *  shown wherever it is asked about:
 *
 *    Organisations      the parties themselves
 *    Users              a person belongs to exactly ONE org (D-87), so a user
 *                       is genuinely a facet of an org rather than a top-level
 *                       thing that exists independently of one
 *    Role assignments   assigning is an act ON an org. Role DEFINITIONS are
 *                       platform config and live under Settings, deliberately
 *                       far away: defining is rare, ours and dangerous;
 *                       assigning is frequent and theirs
 *    Entitlements       granting is an act on an org ("give them Fleet Pro").
 *                       "Who holds Fleet Pro?" is a different question and
 *                       belongs on Products — same rows, two angles
 *
 *  Manufacturers deliberately does NOT appear here or in Asset Catalog: a maker
 *  is an organisation with `party_role = manufacturer` (§9c), so it is this
 *  list filtered, never a second home for the same party.
 */
export function OrganisationsModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/organisations" tabs={[
          { path: "organisations", label: "Organisations" },
          { path: "users", label: "Users" },
        ]} />
      </div>
      <Routes>
        {/* Each route gets a DISTINCT key. Sibling routes rendering the same
            component type at the same tree position reconcile instead of
            remounting — props update while every useState keeps the previous
            tab's value, which is "the heading of one subpage over the contents
            of another" (D-84). A CONSTANT key reproduces the bug exactly, so
            the keys must differ. */}
        <Route path="organisations" element={<OrganisationsPage key="organisations" />} />
        <Route path="users" element={<OrgUsersPage key="users" />} />
        {/* Detail sits UNDER the list rather than as a tab: it is one org,
            reached from a row, and its own tabs are inside it. */}
        <Route path="organisations/:orgId" element={<OrganisationDetailPage key="detail" />} />
        <Route path="*" element={<Navigate to="organisations" replace />} />
      </Routes>
    </>
  );
}
